import { render, staticRenderFns } from "./QuestionSearch.vue?vue&type=template&id=94dc8054"
import script from "./QuestionSearch.vue?vue&type=script&lang=js"
export * from "./QuestionSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports